import fetcher from "../../../../../dataProvider";

export const getChannelLastSeenTime = async (channelId) => {
  let response = await fetcher.get(`/v1/user/activity?channelId=${channelId}`);
  let lastSeenMessageTimestamp = response?.lastSeenMessageTimestamp;
  if (lastSeenMessageTimestamp) {
    return lastSeenMessageTimestamp;
  } else return 0;
};

export const getThreadLastSeenTime = async (channelId, threadId) => {
  let response = await fetcher.get(
    `/v1/user/activity?channelId=${channelId}&threadId=${threadId}`
  );
  let lastSeenMessageTimestamp = response?.lastSeenMessageTimestamp;
  if (lastSeenMessageTimestamp) {
    return lastSeenMessageTimestamp;
  } else return 0;
};

export const getUnreadMessagesCount = async (
  channel,
  lastSeenMessageTimestamp
) => {
  let response = await fetcher.get(
    `/v1/message?channelId=${channel}&fromDate=${lastSeenMessageTimestamp}&updateLastSeen=false`
  );
  let totalUnreadCount = response?.totalResults;
  if (totalUnreadCount) return totalUnreadCount;
  else return 0;
};

export const getChannelUnreadCount = async (channelId) => {
  let lastSeenMessageTimestamp = await getChannelLastSeenTime(channelId);
  if (lastSeenMessageTimestamp) {
    let channelUnreadCount = await getUnreadMessagesCount(
      channelId,
      lastSeenMessageTimestamp
    );
    return channelUnreadCount;
  } else return 0;
};

export const getUnreadMessageList = async (channelId) => {
  let lastSeenMessageTimestamp = await getChannelLastSeenTime(channelId);
  if (lastSeenMessageTimestamp) {
    let response = await fetcher.get(
      `/v1/message?channelId=${channelId}&fromDate=${lastSeenMessageTimestamp}&updateLastSeen=false&limit=1000`
    );
    if (response?.result) return response?.result;
    else return [];
  }
  return [];
};

export const getThreadUnreadMessageList = async (channelId, threadId) => {
  let lastSeenMessageTimestamp = await getThreadLastSeenTime(
    channelId,
    threadId
  );
  if (lastSeenMessageTimestamp) {
    let response = await fetcher.get(
      `/v1/message?channelId=${channelId}&threadId=${threadId}&fromDate=${lastSeenMessageTimestamp}&updateLastSeen=false&limit=1000`
    );
    if (response?.result) return response?.result;
    else return [];
  }
  return [];
};

export const resetLastSeenMessageTimeStamp = async (
  channelId,
  lastSeenMessageTimestamp,
  threadId = null
) => {
  let response;
  if (threadId == null) {
    response = await fetcher.post(`/v1/user/activity`, {
      channelId,
      lastSeenMessageTimestamp,
    });
  } else {
    response = await fetcher.post(`/v1/user/activity`, {
      channelId,
      lastSeenMessageTimestamp,
      threadId,
    });
  }

  if (response) {
    return response;
  } else {
    return 0;
  }
};

export const getCommunityUnreadMessagCountList = async (channels) => {
  let response = await Promise.all(
    channels.map((channelItem) => {
      return getChannelLastSeenTime(channelItem?._id);
    })
  )
    .then(async (results) => {
      return await Promise.all(
        results.map((lastSeenTimestamp, index) =>
          lastSeenTimestamp
            ? getUnreadMessagesCount(channels[index]?._id, lastSeenTimestamp)
            : 0
        )
      ).then((values) => {
        return values;
      });
    })
    .then((values) => {
      return values.map((value, index) => {
        return {
          channelId: channels[index]?._id,
          count: value,
        };
      });
    });

  return response;
};
